import React, { Component } from 'react';
import $ from 'jquery';

import wulingstore from '../assets/images/wulingstore.png';
import favicon from '../assets/images/favicon.png';
import img3 from '../assets/images/person_3.jpg';

class SectionTestimoni extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
    this.clickTab = this.clickTab.bind(this);
  }

  clickTab(id, content) {
    $(`#v-pills-1-tab`).removeClass('active')
    $(`#v-pills-2-tab`).removeClass('active')
    $(`#v-pills-3-tab`).removeClass('active')
    $(`#v-pills-4-tab`).removeClass('active')
    $(`#v-pills-5-tab`).removeClass('active')

    $(`#v-pills-1`).removeClass('show active')
    $(`#v-pills-2`).removeClass('show active')
    $(`#v-pills-3`).removeClass('show active')
    $(`#v-pills-4`).removeClass('show active')
    $(`#v-pills-5`).removeClass('show active')

    $(`#${id}`).addClass('active')
    $(`#${content}`).addClass('show active animated fadeIn')
  }

  render() { 
    return (
      <section className="ftco-section bg-light" id="schedule-section">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-md-12 heading-section text-center" data-aos="fade-up">
              <span className="subheading">Template</span>
              <h2 className="mb-4">Website Template & Portofolio</h2>
              {/* <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p> */}
            </div>
          </div>
          <div className="ftco-schedule">
            <div className="row">
              <div className="col-md-4 nav-link-wrap">
                <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  <a style={{cursor: 'pointer'}} className="nav-link active" id="v-pills-1-tab" onClick={() => this.clickTab('v-pills-1-tab', 'v-pills-1')}>Product Listing</a>
                  <a style={{cursor: 'pointer'}} className="nav-link" id="v-pills-2-tab" onClick={() => this.clickTab('v-pills-2-tab', 'v-pills-2')}>Company Profile</a>
                  <a style={{cursor: 'pointer'}} className="nav-link" id="v-pills-3-tab" onClick={() => this.clickTab('v-pills-3-tab', 'v-pills-3')}>Wedding Invitation</a>
                  <a style={{cursor: 'pointer'}} className="nav-link" id="v-pills-4-tab" onClick={() => this.clickTab('v-pills-4-tab', 'v-pills-4')}>Web Campaign</a>
                  <a style={{cursor: 'pointer'}} className="nav-link" id="v-pills-5-tab" onClick={() => this.clickTab('v-pills-5-tab', 'v-pills-5')}>Virtual Tour</a>
                </div>
              </div>
              <div className="col-md-8 tab-wrap">
                <div className="tab-content" id="v-pills-tabContent">
                  <div className="tab-pane fade show active" id="v-pills-1">
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://commerce2-samawa.firebaseapp.com" target="_blank">Snipp</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="v-pills-2">
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://profile1-samawa.web.app/" target="_blank">Dog Life</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://profile2-samawa.web.app/" target="_blank">Capture</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="v-pills-3">
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://wedding1-samawa.web.app/" target="_blank">Wedding</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://wedding2-samawa.web.app/" target="_blank">Sunshine</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://wedding3-samawa.web.app/" target="_blank">Wed</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="v-pills-4">
                    {/* <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${wulingstore})`}}></div>
                      <div className="text pl-md-5">
                        <span className="time">08:00AM - 10:00AM</span>
                        <h2><a href="#">Introduction to Wordpress 8.0</a></h2>
                        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>
                        <h3 className="speaker-name">&mdash; <a href="#">Brett Morgan</a> <span className="position">Founder of Wordpress</span></h3>
                      </div>
                    </div> */}
                  </div>
                  <div className="tab-pane fade" id="v-pills-5">
                    <div className="speaker-wrap d-flex">
                      <div className="img speaker-img" style={{backgroundImage: `url(${favicon})`}}></div>
                      <div className="text pl-md-5">
                        <h2><a href="https://samawa-vr.web.app" target="_blank">Virtual Tour</a></h2>
                        <p>-</p>
                        {/* <h3 className="speaker-name">&mdash; <a>Alvino Pratama</a> <span className="position">Sales Executive</span></h3> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
 
export default SectionTestimoni;